.wrapper {
    :global {
        .checklist {
            .checklist-item {
                display: flex;
                gap: 4px;
                margin-top: 8px;
            }
        }
    }
}